import createLucideIcon from '../createLucideIcon';

/**
 * @component @name UserCog2
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTQgMTlhNiA2IDAgMCAwLTEyIDAiIC8+CiAgPGNpcmNsZSBjeD0iOCIgY3k9IjkiIHI9IjQiIC8+CiAgPGNpcmNsZSBjeD0iMTkiIGN5PSIxMSIgcj0iMiIgLz4KICA8cGF0aCBkPSJNMTkgOHYxIiAvPgogIDxwYXRoIGQ9Ik0xOSAxM3YxIiAvPgogIDxwYXRoIGQ9Im0yMS42IDkuNS0uODcuNSIgLz4KICA8cGF0aCBkPSJtMTcuMjcgMTItLjg3LjUiIC8+CiAgPHBhdGggZD0ibTIxLjYgMTIuNS0uODctLjUiIC8+CiAgPHBhdGggZD0ibTE3LjI3IDEwLS44Ny0uNSIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/user-cog-2
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const UserCog2 = createLucideIcon('UserCog2', [
  ['path', { d: 'M14 19a6 6 0 0 0-12 0', key: 'vej9p1' }],
  ['circle', { cx: '8', cy: '9', r: '4', key: '143rtg' }],
  ['circle', { cx: '19', cy: '11', r: '2', key: '1rxg02' }],
  ['path', { d: 'M19 8v1', key: '1iffrw' }],
  ['path', { d: 'M19 13v1', key: 'z4xc62' }],
  ['path', { d: 'm21.6 9.5-.87.5', key: '6lxupl' }],
  ['path', { d: 'm17.27 12-.87.5', key: '1rwhxx' }],
  ['path', { d: 'm21.6 12.5-.87-.5', key: 'agvc9a' }],
  ['path', { d: 'm17.27 10-.87-.5', key: '12d57s' }],
]);

export default UserCog2;
